module.exports = "/assets/images/media-user.png?f8e7cf33cb3d44177bc3fed5d99e7b34";